import clsxm from "@/lib/clsxm";
import {useManagedCampaignType} from "@/store/campaignManagement";
import dayjs from "dayjs";
import {useState, type FC, type ReactNode} from "react";
import {useTranslation} from "react-i18next";

const TRUNCATED_CAPTION_INSTAGRAM_LIMIT = 125;
const TRUNCATED_CAPTION_TIKTOK_LIMIT = 52;

const ContentGuidanceBox: FC<{
  className?: string;
  date?: string | null;
  description?: string;
  descriptionClassName?: string;
  descriptionTextClassName?: string;
  expandableButtonClassName?: string;
  isExpandable?: boolean;
  influencerImage?: string | null;
  title: string;
  titleClassName?: string;
  titleIcon?: ReactNode;
}> = ({
  className,
  date,
  description,
  descriptionClassName,
  descriptionTextClassName,
  expandableButtonClassName,
  isExpandable = true,
  influencerImage,
  title,
  titleClassName,
  titleIcon,
}) => {
  const {t} = useTranslation("common");
  const campaignType = useManagedCampaignType();
  const [isExpanded, setExpanded] = useState(!isExpandable);
  const truncateLimit = campaignType === "tiktok" ? TRUNCATED_CAPTION_TIKTOK_LIMIT : TRUNCATED_CAPTION_INSTAGRAM_LIMIT;
  const isLong = description && description.length > truncateLimit;

  return (
    <div
      className={clsxm(
        "bg-neutral-white-dark flex max-h-33.5 w-full flex-col gap-1 rounded-sm py-3",
        isLong && "min-h-33.5",
        className,
      )}>
      <span
        className={clsxm(
          "text-neutral-grey-dark bg-neutral-white-dark text-2xs flex items-center rounded-t-sm px-3 leading-3.5 font-semibold uppercase",
          titleClassName,
        )}>
        {titleIcon}
        {title}
      </span>
      <div
        className={clsxm(
          "bg-neutral-white-dark scrollbar-hide flex grow flex-col justify-between gap-1 overflow-y-auto rounded-b-sm px-3",
          descriptionClassName,
        )}>
        <div className="flex gap-3">
          {influencerImage && <img className="size-6 rounded-full" src={influencerImage} />}
          <div className="flex flex-col gap-2">
            <p className={clsxm("text-neutral-black m-0 text-xs", descriptionTextClassName)}>
              {!isExpanded && isLong ? description.slice(0, truncateLimit) + "..." : description}
            </p>
            {isLong && isExpandable && (
              <button onClick={() => setExpanded(!isExpanded)} className="flex items-start">
                <span className={clsxm("text-neutral-black text-sm font-bold", expandableButtonClassName)}>
                  {t(isExpanded ? "less" : "more")}
                </span>
              </button>
            )}
          </div>
        </div>
        {date && (
          <span className="text-sm whitespace-nowrap text-white">
            {t("uploaded")} {dayjs(date).format("DD.MM.YYYY")}
          </span>
        )}
      </div>
    </div>
  );
};

export default ContentGuidanceBox;
